import { isEqual } from 'lodash'
import Form from '../ui/Form'

export default class SettingsItemForm extends Form {

  componentWillMount(){
    this.setState({
      editing: false,
      delConf: false,
      data: {...this.props.data},
      errors: {}
    });
  }

  saveItem = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(data, this.props.data)) {
      this.cancelEditing();
    }
    else {
      this.props.editSets(this.modelName, data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.cancelEditing();
      });
    }
  }

  deleteItem = e => {
    e.preventDefault();
    this.props.editSets(this.modelName, {
      ...this.props.data,
      [this.modelName + '_active']: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.cancelEditing();
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/settings/SettingsItemForm.jsx